// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__INYg2","type":"styles_type__30ZiK","choices":"styles_choices__2zV-e"};